import { render } from "./LocationDistribution.vue?vue&type=template&id=388f9b49&scoped=true"
import script from "./LocationDistribution.vue?vue&type=script&lang=js"
export * from "./LocationDistribution.vue?vue&type=script&lang=js"

import "./LocationDistribution.vue?vue&type=style&index=0&id=388f9b49&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/DBCapacity-VUE/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388f9b49"]])

export default __exports__